export const environment = {
	production: true,
	url: "https://future.portal.partikelart.de",
	redirect: "https://demo.portal.partikelart.com",
	logLevel: "error",
	demo: true,
	logoutRedirectUrl: "https://partikel-art.de",
	staging: false,
	/**
	 * Demo deployment backend.
	 * Keep this set so backend-driven user/customer resolution can be exercised
	 * when the demo interceptor is not in control of the request.
	 */
	portalBackendUrl: "http://localhost:3000",
	/** Keep empty for user-authenticated demo flows. */
	portalApiKey: "",
	customer: "demo",
	deploymentType: "cloud",
	version: "PLACEHOLDER_GIT_HASH",
	trapsEnabled: true,
};
